module.exports = __webpack_public_path__ + "img/self1.3d9fda79.svg";